module.exports = __webpack_public_path__ + "static/media/greyThreeDots.0e7b34f4.svg";